import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "list" }
const _hoisted_2 = {
  key: 1,
  class: "noResults"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_list_element = _resolveComponent("list-element")!

  return (_ctx.hasResults)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "listContainer",
        onScroll: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onScroll && _ctx.onScroll(...args)))
      }, [
        _createElementVNode("div", _hoisted_1, [
          (_ctx.newArtistActive)
            ? (_openBlock(), _createBlock(_component_list_element, {
                key: 0,
                new: true,
                color: "green"
              }))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.addColors(_ctx.artists), (artist) => {
            return (_openBlock(), _createBlock(_component_list_element, {
              key: artist,
              artist: artist,
              color: artist.color,
              onArtistsLikeThis: ($event: any) => (_ctx.artistsLikeThis(artist))
            }, null, 8, ["artist", "color", "onArtistsLikeThis"]))
          }), 128))
        ])
      ], 32))
    : (_openBlock(), _createElementBlock("p", _hoisted_2, " no search results :( "))
}